module.exports = __webpack_public_path__ + "img/geschmiedetestor.731ce17d.jpg";